var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "35px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("员工转正")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "780px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("城市")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.city_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "city_id", $$v)
      },
      expression: "condition.city_id"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("职位")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.post_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "post_id", $$v)
      },
      expression: "condition.post_id"
    }
  }, _vm._l((_vm.gwList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.condition.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_card", $$v)
      },
      expression: "condition.staff_card"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("入职日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "datetimerange",
      "clearable": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "format": "yyyy-MM-dd HH:mm",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.condition.start_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "start_date", $$v)
      },
      expression: "condition.start_date"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("转正时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.formal_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "formal_date", $$v)
      },
      expression: "condition.formal_date"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.is_formal),
      callback: function($$v) {
        _vm.$set(_vm.condition, "is_formal", $$v)
      },
      expression: "condition.is_formal"
    }
  }, _vm._l((_vm.ztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "220px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "转正人员清单",
      "name": "转正人员清单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t导表")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "3% 2% 0 2%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "530"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "组织架构",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$globals.group_name + "/" + scope.row.organize_name) + "\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city_id",
      "label": "城市",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "label": "职位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "姓名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_card",
      "label": "身份证号码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_telephone",
      "label": "手机号码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trial_salary",
      "label": "试用期薪酬",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "试用期起止时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.start_date + "—" + scope.row.end_date) + "\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formal_date",
      "label": "转正时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formal_salary",
      "label": "转正薪筹",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.is_formal === '0'),
            expression: "scope.row.is_formal === '0' "
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_未生效.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.is_formal === '1'),
            expression: "scope.row.is_formal === '1' "
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已生效.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.is_formal === '0'),
            expression: "scope.row.is_formal === '0' "
          }],
          attrs: {
            "type": "qian"
          },
          on: {
            "click": function($event) {
              return _vm.zhuanzheng(scope.row)
            }
          }
        }, [_vm._v("转正")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.is_formal === '1'),
            expression: "scope.row.is_formal === '1' "
          }],
          staticStyle: {
            "background-color": "#f6f6f6",
            "color": "#000000",
            "border-color": "#f6f6f6"
          },
          attrs: {
            "type": "qian"
          }
        }, [_vm._v("转正")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "转正",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('div', [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "转正时间",
      "prop": "formal_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.formal_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "formal_date", $$v)
      },
      expression: "ruleForm.formal_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "转正薪资",
      "prop": "formal_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入转正薪资"
    },
    model: {
      value: (_vm.ruleForm.formal_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "formal_salary", $$v)
      },
      expression: "ruleForm.formal_salary"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddAuditor('ruleForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "500px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择审核人",
      "visible": _vm.dialogAuditorVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAuditorVisible = $event
      }
    }
  }, [_c('SelectAuditor', {
    ref: "SelectAuditor",
    attrs: {
      "type": 13,
      "examineDetailsList": _vm.ruleForm.examineDetailsList,
      "id": _vm.ruleForm.id
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c4d968","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygzz/Ygzz.vue
// module id = null
// module chunks = 